import React from 'react';

import Stack from '~/common/components/Stacks/Stack';

type HStackProps = React.ComponentPropsWithRef<typeof Stack> & {
  as?: React.ElementType;
  children?: React.ReactNode;
};

const HStack = React.forwardRef<unknown, HStackProps>(
  ({ children, ...props }, ref) => {
    return (
      <Stack direction="row" spacing={2} ref={ref} {...props}>
        {children}
      </Stack>
    );
  },
);

HStack.displayName = 'HStack';

export default HStack;
